import React, {useState} from'react';
import { Col, Row } from "antd";
import { useResponsive } from "../hooks/responsive";
import stateWrapper from '../containers/provider';
import { Link } from "react-router-dom";
import Cancel from '../assets/images/cancel.svg';



const Message = ({
    onClose = () => {},
    title,
    description,
    isActive = false,
    style = {},
    ...props
}) => {
    const [isTabletOrMobileDevice, isTabletOrMobile, isBigScreen, isDesktopOrLaptop, isPortrait, isRetina, isTablet] = useResponsive();
    const handlePhoneClick = () => {
        onclose();
    }
  return (
    <>
        {isActive && (
            <div className="glass-light" style={{padding: 20, position: 'absolute', top: isTabletOrMobileDevice? '10%' : '7%', right: 20, paddingTop: 5, height: 100, ...style}}>
                <div onClick={onClose}>
                    <img 
                        src={Cancel} 
                        style={{
                            width: 20,
                            height: 20,
                            cursor: 'pointer'
                        }} 
                    />
                </div>
                <div style={{fontSize: 14, fontFamily: "'Montserrat', sans-serif", color: '#FFFFFF', textAlign: 'center'}}>
                    {title}
                </div>
                <div style={{fontSize: 14, fontWeight: 'lighter', fontFamily: "'Montserrat', sans-serif", color: '#FFFFFF', textAlign: 'center', marginBottom: 10}}>
                    {description}
                </div>
            </div>
        )}
    </>
  );
}

export default stateWrapper(Message);
